<ng-template #namedResultTemplate let-r="result" let-t="term">
  <ng-container *ngIf="cullAtomAutocomplete">
    <ng-container *ngIf="r === t;">
      <i>{{t}}</i>
    </ng-container>
    <ng-container *ngIf="r !== t">
      <ngb-highlight [result]="r" [innerHTML]="r |truncate:30" [term]="t"></ngb-highlight>
    </ng-container>
  </ng-container>
</ng-template>
<div class="modal-header">
  <h5 class="modal-title">{{ options.title }} </h5>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-6">
      <div class="mb-2">
        <div class="d-flex justify-content-between">
          <span>{{'lang.globals.searchMode'|translate}}:</span>
        </div>
        <div class="d-flex align-items-center">
          <sb-radio-group
            [titles]="{ Exact: 'Exact' , Prefix: 'Prefix', Suffix: 'Suffix', Contains: 'Contains' }"
            [selectionsHovers]="{
            Exact: ('lang.globals.searchExact' |translate),
            Prefix: ('lang.globals.searchPrefix'|translate),
            Suffix: ('lang.globals.searchSuffix'|translate),
            Contains: ('lang.globals.searchContains'|translate)
            }"
            [selections]="selectionsAllowed"
            (selected)="changeMode($event)" [selectedVal]="selectedMode"></sb-radio-group>
        </div>
      </div>
      <div class="form-group dropdownDeep d-flex align-items-center m-0">
        <button class="btn btn-default" container="body"
                [ngbTooltip]="'lang.globals.search'|translate" (click)="openSuggestions()">
          <sb-icon class="icon-in-btn" icon="search"></sb-icon>
        </button>
        <ng-container
          *ngIf="cullAtomAutocomplete; else searchElse">
          <input type="text" class="form-control mx-sm-3" [class.is-invalid]="searchFailed || pasteFailed"
                 [(ngModel)]="searchStr" #inputElementIf
                 style="width: auto"
                 [ngbTypeahead]="dosearch" placeholder="..." [resultTemplate]="namedResultTemplate"
                 [editable]='true' (keyup.enter)="enterPressed()"
                 (selectItem)="selectedItem($event)"/>
        </ng-container>
        <ng-template #searchElse>
          <input type="text" class="form-control mx-sm-3" [class.is-invalid]="searchFailed || pasteFailed"
                 [(ngModel)]="searchStr" #inputElementElse
                 [ngbTypeahead]="dosearch" placeholder="..." (keyup.enter)="enterPressed()"/>
        </ng-template>
        <sb-icon class="cursor-pointer" icon="paste" (click)="pasteDataFromClipboard()"></sb-icon>
        <sb-icon class="cursor-pointer ml-2" icon="empty" (click)="insertEmptyValue()"></sb-icon>
        <div class="invalid-feedback" *ngIf="searchFailed">{{'lang.globals.searchFailed'|translate}}</div>
        <div class="invalid-feedback" *ngIf="pasteFailed">{{'lang.globals.pasteFailed'|translate}}</div>
      </div>
      <p>
        &nbsp;<small *ngIf="searching" class="form-text text-muted">{{'lang.globals.searching'|translate}}</small>
      </p>
    </div>
    <div class="col-6 valuelist bg-modal">
      <div class="row">
        <div class="col-8 valuerow">
          <div class="valuerowvalue">
            <b>
              {{ 'lang.globals.selectedValues' | translate }}
            </b>
          </div>
        </div>
        <div class="col-4 valuerow">
          <div class="red valuerowvalue cursor-pointer text-end" (click)="removeAll()">
            {{'lang.culls.culltype.all' | translate}}
            <sb-icon [icon]="'trash'"></sb-icon>
          </div>
        </div>
      </div>
      <div class="row" style="overflow-y: auto; max-height: 260px">
        <div class="col-12">

          <div class="row" *ngFor="let option of selectedOptions">
            <div class="col-10 valuerow">
              <div class="valuerowvalue">
                <i *ngIf="option === ''; else theElse">
                  {{'lang.globals.empty'|translate}}
                </i>
                <ng-template #theElse>
                  <span [innerHTML]="option |truncate:30"></span>
                </ng-template>
              </div>
            </div>
            <div class="col-2 valuerow">
              <div class="valuerowvalue valuerowvaluetrash">
                <sb-icon class="cursor-pointer red" [icon]="'trash'" (click)="removeOption(option)"></sb-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <sb-button classes="btn-primary" (click)="ok()" [disabled]="!checkOkEnabled()">{{ 'lang.globals.ok' | translate }}
  </sb-button>
  <sb-button classes="btn-default" (click)="cancel()">{{ 'lang.globals.cancel' | translate }}
  </sb-button>
</div>
